import * as React from 'react';
import { getIndexFromItem, getContainerMetadata, getShuttleItem } from '../../../utils/utils';
import { SHUTTLE_CONTROL_TYPES } from '../reducers/index';
export function useShuttleItemClick({ setShuttleState }) {
    const onClick = React.useCallback((e) => {
        const target = getShuttleItem(e.target);
        if (target && target.className.includes('shuttle__item')) {
            const index = getIndexFromItem(target);
            const container = target.closest('.shuttle__container');
            if (container) {
                const { source } = getContainerMetadata(container);
                const action = {
                    type: SHUTTLE_CONTROL_TYPES.SELECT_ITEM,
                    container: source ? 'source' : 'target',
                    index,
                };
                setShuttleState(action);
            }
        }
    }, [setShuttleState]);
    return { onClick };
}
